
import FormField from "../../base_classes/FormField"
import { Component, Vue, Prop, Watch } from "vue-property-decorator"

import { Formatting } from "../../util/formatting"
import moment from "moment"

@Component({
    components: {
        SelectWorkDateDialog: () => import("../dialogs/SelectWorkDateDialog.vue"),
    },
})
export default class DateField extends FormField {
    show: boolean = false

    @Prop() label!: string
    @Prop() field!: string
    @Prop() setDefault?: boolean
    @Prop() error?: boolean
    @Prop() clearable?: boolean
    @Prop() minDate?: any

    mounted() {
        if (this.setDefault && this.value && !this.value[this.field]) {
            Vue.set(this.value, this.field, new Date().getTime())
        }
    }

    handleSelect(event: any) {
        Vue.set(this.value, this.field, event)
        this.$emit("input", this.value)
    }

    get formattedDate() {
        if (!this.value[this.field]) return ""
        var date = this.value[this.field]
        if (!isNaN(date) && typeof date == "string") date = Number(date)
        return moment(date).format("YYYY-MM-DD")
    }

    get date() {
        return new Date(this.value[this.field])
    }

    clickClear(e: any) {
        console.log(e)
        e.preventDefault()
        this.value[this.field] = null
        this.$emit("clear")
    }

}
